import {Component, matchExpression} from '@packages/systems/wfdl';
import {isBody} from '@packages/utilities/elementTypeUtils';
import {getPageComponentFromComponentMap} from '@packages/utilities/core-elements';
import {type ExpressionElement} from '@packages/systems/wfdl-ast';

const getBodyElement = matchExpression({
  Element: (el: ExpressionElement) => (isBody(el) ? el : undefined),
  _: () => undefined,
});

/**
   Finds the <body> element in a componentMap.
 */
export function getBody(
  components: Component.ComponentMap
): ExpressionElement | undefined {
  const currentPageComponent = getPageComponentFromComponentMap(components);
  return currentPageComponent
    ? getBodyElement(Component.getRender(currentPageComponent))
    : undefined;
}
